module.exports = __webpack_public_path__ + "img/smartphone-navigation.bf09a4fe.png";